import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardUlIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M3.25903 10.594H2.00903C1.57769 10.594 1.22803 10.9437 1.22803 11.375V12.626C1.22803 13.0573 1.57769 13.407 2.00903 13.407H3.25903C3.69036 13.407 4.04003 13.0573 4.04003 12.626V11.375C4.04003 10.9437 3.69036 10.594 3.25903 10.594Z"
        fill={color}
      />
      <path
        d="M3.25903 1.59399H2.00903C1.57769 1.59399 1.22803 1.94366 1.22803 2.37499V3.62599C1.22803 4.05733 1.57769 4.40699 2.00903 4.40699H3.25903C3.69036 4.40699 4.04003 4.05733 4.04003 3.62599V2.37499C4.04003 1.94366 3.69036 1.59399 3.25903 1.59399Z"
        fill={color}
      />
      <path
        d="M3.25903 19.594H2.00903C1.57769 19.594 1.22803 19.9437 1.22803 20.375V21.626C1.22803 22.0573 1.57769 22.407 2.00903 22.407H3.25903C3.69036 22.407 4.04003 22.0573 4.04003 21.626V20.375C4.04003 19.9437 3.69036 19.594 3.25903 19.594Z"
        fill={color}
      />
      <path
        d="M6.5 13L23.5 13C23.7761 13 24 12.7761 24 12.5V11.5C24 11.2239 23.7761 11 23.5 11L6.5 11C6.22386 11 6 11.2239 6 11.5V12.5C6 12.7761 6.22386 13 6.5 13Z"
        fill={color}
      />
      <path
        d="M6.5 22L23.5 22C23.7761 22 24 21.7761 24 21.5V20.5C24 20.2239 23.7761 20 23.5 20L6.5 20C6.22386 20 6 20.2239 6 20.5V21.5C6 21.7761 6.22386 22 6.5 22Z"
        fill={color}
      />
      <path
        d="M6.5 4L23.5 4C23.7761 4 24 3.77614 24 3.5V2.5C24 2.22386 23.7761 2 23.5 2L6.5 2C6.22386 2 6 2.22386 6 2.5V3.5C6 3.77614 6.22386 4 6.5 4Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardUlIcon.displayName = 'BoardUlIcon';
